module.exports = __webpack_public_path__ + "media/images/proof_links/colored/marketyandex-c6cb5655355788a632c4127830025568.svg";